export interface S3Config {
  bucket: string;
  region: string;
  accessKeyId: string;
  secretAccessKey: string;
}

export const s3Config: S3Config = {
  bucket: import.meta.env.VITE_AWS_STORAGE_BUCKET_NAME,
  region: import.meta.env.VITE_AWS_S3_REGION_NAME,
  accessKeyId: import.meta.env.VITE_AWS_ACCESS_KEY_ID,
  secretAccessKey: import.meta.env.VITE_AWS_SECRET_ACCESS_KEY,
};
